// Mobile buy bar: reveals once the main add-to-cart button has scrolled above the viewport, hides again near the footer.
class StickyBuy extends HTMLElement {
  #observer = null;
  #targetAbove = false;
  #footerVisible = false;

  connectedCallback() {
    const target = document.getElementById(this.dataset.target || '');
    const footer = document.querySelector('body > footer');
    if (!target) return;

    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === target) {
          this.#targetAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        } else {
          this.#footerVisible = entry.isIntersecting;
        }
      }
      this.#update();
    });

    this.#observer.observe(target);
    if (footer) this.#observer.observe(footer);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #update() {
    const show = this.#targetAbove && !this.#footerVisible;
    this.toggleAttribute('data-visible', show);
    this.toggleAttribute('inert', !show);
  }
}

if (!customElements.get('s-sticky-buy')) {
  customElements.define('s-sticky-buy', StickyBuy);
}
